module.exports = __webpack_public_path__ + "img/icon2.10c24526.png";